import { render, staticRenderFns } from "./NewYear.vue?vue&type=template&id=5cb4847b&scoped=true&"
import script from "./NewYear.vue?vue&type=script&lang=js&"
export * from "./NewYear.vue?vue&type=script&lang=js&"
import style0 from "./NewYear.vue?vue&type=style&index=0&id=5cb4847b&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb4847b",
  null
  
)

component.options.__file = "NewYear.vue"
export default component.exports